import { gql } from "@apollo/client";

export const FETCH_ALL_CAMPAIGNS = gql`
	query SearchCampaignBehaviors($filters: CampaignBehaviorsFilterInput) {
		allCampaignBehaviors(filters: $filters) {
			campaignBehaviorId
			campaignTitle
			campaignStatus
			operatorId
			lockerId
			campaignBehaviorTypeNo
			campaignBehaviorParameters
			campaignRewardTypeNo
			campaignRewardParameters
			campaignRedemptionLimit
			userRedemptionLimit
			startDate
			isExpired
			endDate
			remarks
			createdAt
			updatedAt
		}
	}
`;

export const FILTER_BEHAVIORAL_CAMPAIGN_BY_STATUS = gql`
	query SearchCampaignBehaviors($filters: CampaignBehaviorsFilterInput) {
		allCampaignBehaviors(filters: $filters) {
			campaignBehaviorId
			campaignTitle
			campaignStatus
			isExpired
		}
	}
`;

export const ADD_BEHAVIORAL_CAMPAIGN = gql`
	mutation UpsertCampaignBehavior(
		$id: Int
		$title: String
		$status: Int
		$operatorId: Int
		$lockerIds: [Int]
		$behaviorType: Int
		$behaviorParams: JSONString
		$rewardType: Int
		$rewardParams: JSONString
		$redemptionLimit: Int
		$userLimit: Int
		$startDate: DateTime
		$endDate: DateTime
		$remarks: String
	) {
		upsertCampaignBehavior(
			campaignBehaviorId: $id # bakit po nasa args to
			campaignTitle: $title # campaignName
			campaignStatus: $status # default 1 kapag bagong add
			operatorId: $operatorId # get from ls
			lockerId: $lockerIds # array, or 0 if all
			campaignBehaviorTypeNo: $behaviorType # 1 [Early Pickup] || 2 [Total Packages Claimed]
			campaignBehaviorParameters: $behaviorParams #
			campaignRewardTypeNo: $rewardType
			campaignRewardParameters: $rewardParams
			campaignRedemptionLimit: $redemptionLimit
			userRedemptionLimit: $userLimit
			startDate: $startDate
			endDate: $endDate
			remarks: $remarks
		) {
			campaignBehavior {
				campaignBehaviorId
				campaignTitle
				campaignStatus
				operatorId
				lockerId
				campaignBehaviorTypeNo
				campaignBehaviorParameters
				campaignRewardTypeNo
				campaignRewardParameters
				campaignRedemptionLimit
				userRedemptionLimit
				startDate
				endDate
				remarks
				createdAt
				updatedAt
			}
		}
	}
`;
